import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Alert, Button } from "reactstrap";

import {
  clearStudioSwitchBanner,
  getStudioSwitchBanner,
} from "../../helpers/identity_storage";

const StudioSwitchBanner = () => {
  const { t } = useTranslation();
  const [tenantName, setTenantName] = useState<string | null>(null);

  useEffect(() => {
    const banner = getStudioSwitchBanner();

    if (!banner) {
      return;
    }

    setTenantName(banner.tenantName);

    const remaining = Math.max(0, banner.expiresAt - Date.now());
    const timeoutId = window.setTimeout(() => {
      clearStudioSwitchBanner();
      setTenantName(null);
    }, remaining || 1);

    return () => window.clearTimeout(timeoutId);
  }, []);

  if (!tenantName) {
    return null;
  }

  return (
    <Alert color="success" className="rounded-0 mb-0 border-0 d-flex align-items-center justify-content-between flex-wrap gap-2 px-3 py-2">
      <span className="mb-0">
        <i className="ri-store-2-line me-1 align-middle" aria-hidden />
        {t("auth.switch_studio.banner", { name: tenantName })}
      </span>
      <Button
        color="link"
        size="sm"
        className="p-0 text-success"
        onClick={() => {
          clearStudioSwitchBanner();
          setTenantName(null);
        }}
      >
        {t("auth.switch_studio.banner_dismiss")}
      </Button>
    </Alert>
  );
};

export default StudioSwitchBanner;
